export const ENDPOINTS = {
  auth: {
    login: '/api/auth/login',
    register: '/api/auth/register',
    refresh: '/api/auth/refresh',
    logout: '/api/auth/logout',
    me: '/api/auth/me',
  },
  platform: {
    bootstrap: '/platform/bootstrap',
    navigation: '/platform/navigation',
  },
  dashboard: {
    overview: '/api/v2/dashboard',
  },
  customers: {
    list: '/api/customers',
    byId: (id: string) => `/api/customers/${id}`,
    projects: (id: string) => `/api/customers/${id}/projects`,
    contracts: (id: string) => `/api/customers/${id}/contracts`,
    opportunities: (id: string) => `/api/customers/${id}/opportunities`,
    invoices: (id: string) => `/api/customers/${id}/invoices`,
  },
  projects: {
    list: '/api/projects',
    byId: (id: string) => `/api/projects/${id}`,
    dashboard: (id: string) => `/api/projects/${id}/dashboard`,
    kanban: (id: string) => `/api/projects/${id}/kanban`,
    tasks: (id: string) => `/api/projects/${id}/tasks`,
    sprints: (id: string) => `/api/projects/${id}/sprints`,
    milestones: (id: string) => `/api/projects/${id}/milestones`,
    members: (id: string) => `/api/projects/${id}/members`,
  },
  employees: {
    list: '/api/employees',
    byId: (id: string) => `/api/employees/${id}`,
    skills: (id: string) => `/api/employees/${id}/skills`,
    career: (id: string) => `/api/employees/${id}/career`,
    performance: (id: string) => `/api/employees/${id}/performance`,
    goals: (id: string) => `/api/employees/${id}/goals`,
  },
  documents: {
    list: '/api/documents',
    byId: (id: string) => `/api/documents/${id}`,
    byResource: (resource: string, resourceId: string) => `/api/documents/resource/${resource}/${resourceId}`,
  },
  indicators: {
    list: '/api/indicators',
    byId: (id: string) => `/api/indicators/${id}`,
    series: (id: string) => `/api/indicators/${id}/series`,
    values: (id: string) => `/api/indicator-series/${id}/values`,
  },
  scores: {
    company: '/api/scores/company',
    department: (id: string) => `/api/scores/departments/${id}`,
    employee: (id: string) => `/api/scores/employees/${id}`,
    history: (entityId: string) => `/api/scores/history/${entityId}`,
  },
  financial: {
    revenue: '/api/revenues',
    expenses: '/api/expenses',
    invoices: '/api/invoices',
    transactions: '/api/transactions',
    metrics: '/api/financial-metrics',
  },
  crm: {
    pipeline: '/api/crm/pipeline',
    contacts: '/api/contacts',
    opportunities: '/api/opportunities',
    contracts: '/api/contracts',
  },
  notifications: {
    list: '/api/notifications',
    unread: '/api/notifications/unread',
    byId: (id: string) => `/api/notifications/${id}`,
    markRead: (id: string) => `/api/notifications/${id}/read`,
  },
  workspace: {
    current: '/api/workspaces/current',
    byId: (id: string) => `/api/workspaces/${id}`,
    members: (id: string) => `/api/workspaces/${id}/members`,
  },
  users: {
    me: '/api/users/me',
    byId: (id: string) => `/api/users/${id}`,
  },
  organizations: {
    current: '/api/organizations/current',
    byId: (id: string) => `/api/organizations/${id}`,
  },
  processes: {
    list: '/api/processes',
    byId: (id: string) => `/api/processes/${id}`,
    steps: (id: string) => `/api/processes/${id}/steps`,
    instances: '/api/workflow-instances',
    automations: '/api/workflow-automations',
    approvals: '/api/approvals',
  },
} as const;